import { FC } from 'react';
import styles from './styles.module.scss';
import Button from '@components/common/button';
import { pageAnimation } from '@const/animation';
import { motion } from 'framer-motion';
import Typography from '@components/common/typography';
import { Icon } from '@components/icons';
import { copyStringToClipboard } from '@utils/index';
import { useLocales } from '@hooks/helpers/useLocales';

interface IProps {
    onSubmit: () => void;
    onPrev: () => void;
    recoveryCode?: string;
}

const BackupCode: FC<IProps> = ({ onPrev, onSubmit, recoveryCode }) => {
    const { submitLocale } = useLocales();
    return (
        <div className={styles.main_wrapper}>
            <motion.div {...pageAnimation} className={styles.wrapper}>
                <div className={styles.text_wrapper}>
                    <Typography weight="semibold" variant="body1" className={styles.title}>
                        Save your 2FA backup code
                    </Typography>
                    <Typography variant="body2" className={styles.description}>
                        We recommend storing your backup code in a safe, secure place—such as a
                        password manager. If you ever lose access to your 2FA device, you can use
                        this code to sign in.
                    </Typography>
                </div>
                <div className={styles.token_wrapper}>
                    <Typography variant="body1">{recoveryCode}</Typography>
                    <button onClick={() => copyStringToClipboard(recoveryCode || '')}>
                        <Icon name="copy" />
                    </button>
                </div>
                <div className={styles.actions}>
                    <Button leftIcon="arrow_left" variant="outlined-primary" onClick={onPrev}>
                        {submitLocale('previous')}
                    </Button>
                    <Button rightIcon="arrow_right" variant="primary" onClick={onSubmit}>
                        {submitLocale('complete_setup')}
                    </Button>
                </div>
            </motion.div>
        </div>
    );
};

export default BackupCode;
